const styles = {
  container: {
    backgroundColor: '#EFECF5',
  },
};

export default styles;
